/** 身份证回退挽留弹窗曝光 */
export const TP_OCR_RETURN_POPUP_EXPOSE = 'finance_loan_ocr_return_popUp';

/** 身份证回退挽留弹窗点击 */
export const TP_OCR_RETURN_POPUP_CLICK = 'finance_loan_ocr_return_popUp';
